import { BsPaintBucket } from 'react-icons/bs';
import FilterColorDropdown from '../filterAtoms/FilterColorDropdown';
import { FilterDropdownProps, UseFilterConfigs } from '../useFilterConfigs';
import { MdFormatColorText } from 'react-icons/md';

interface ColorFilterProps
  extends Pick<FilterDropdownProps, 'stroke'>,
    Pick<UseFilterConfigs, 'changeValue'> {
  colors: string[];
  color: string;
  forFill: boolean;
}

export default function ColorFilter({
  stroke,
  color,
  colors,
  forFill,
  changeValue,
}: ColorFilterProps) {
  const key = forFill ? 'fillColor' : 'textColor';
  return (
    <FilterColorDropdown
      Icon={forFill ? BsPaintBucket : MdFormatColorText}
      stroke={stroke}
      colors={colors}
      color={color}
      changeColor={(color: string) => changeValue(key, color)}
    />
  );
}
